export default __webpack_public_path__ + "fa66a2c77eeb35213bde4e875c9b32ea.png";